import { cn } from '@/utilities/misc'
import './InputFrame.css'
import type { ReactNode } from 'react'
import { Tooltip } from '../action/Tooltip'
import type { Placement } from '@floating-ui/dom'
import { Icon } from '../graphics/Icon'

export type InputFrameProps = {
  label?: ReactNode
  prefix?: ReactNode
  suffix?: ReactNode
  tooltip?: ReactNode
  tooltipPlacement?: Placement
  required?: boolean
  disabled?: boolean
  width?: number | string
  height?: number | string
  className?: string
  children: ReactNode
}

export function InputFrame({
  label,
  prefix,
  suffix,
  tooltip,
  tooltipPlacement,
  required,
  disabled,
  width,
  height,
  className,
  children,
}: InputFrameProps) {

  const suffixSpaced = suffix &&
    typeof suffix === 'string' &&
    suffix[0] === ' '

  return (
    <table
      className={cn(
        'InputFrame',
        className,
        !!label && 'HasLabel',
      )}
      style={{
        ...(width ? {
          width: '100%',
          maxWidth: width
        } : {}),
        ...(height ? { height } : {}),
      }}
    >
      <tbody>

        {label && (
          <tr>
            <td></td>
            <td
              className='Label'
              colSpan={suffix ? 2 : 1}
            >
              {required && (
                <span className='Required'>
                  <Tooltip placement='top' disabled={disabled}>
                    Required
                  </Tooltip>
                  <Icon icon='asterisk' />
                </span>
              )}
              <span>
                {label}
              </span>
            </td>
          </tr>
        )}

        <tr>
          <td className={cn('Prefix', !prefix && 'Empty')}>
            {prefix ?? <>&nbsp;</>}
          </td>
          <td className='Content'>
            <Tooltip placement={tooltipPlacement} disabled={disabled}>
              {tooltip}
            </Tooltip>
            {children}
          </td>
          {suffix && (
            <td className='Suffix'>
              {suffixSpaced && <>&nbsp;</>}
              {suffix}
            </td>
          )}
        </tr>

      </tbody>
    </table>
  )
}